"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Image = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const utils_1 = require("@obvio/utils");
const image_1 = __importDefault(require("next/legacy/image"));
const react_1 = require("react");
const upng_js_1 = require("upng-js");
const hooks_1 = require("./hooks");
const env_1 = require("../env");
const styled_1 = require("../theme/styled");
const PLACEHOLDER_IMAGE_WIDTH = 10;
const PLACEHOLDER_IMAGE_HEIGHT = 10;
const PLACEHOLDER_IMAGE_COLORS = 256;
const getPlaceholder = (color) => `url(data:image/svg+xml;charset=utf-8,${encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 283 228"><circle cx="115.3" cy="35.8" r="35.8" fill="${color}"/><path fill="${color}" d="M189 228h-82c-10 0-16-12-10-20l39-56 42-61a12 12 0 0 1 21 0l43 61 38 56c6 8 0 20-10 20h-81z"/><path fill="${color}" d="m2 207 56-79c4-6 13-8 19-3l112 78c11 8 6 25-7 25H13c-10 0-17-12-11-21z"/></svg>`)})`;
const placeholderStyle = (0, styled_1.css) `
  background-size: 30% auto;
  background-color: ${(theme) => theme.colors.gray.light};
  background-image: ${(theme) => getPlaceholder(theme.colors.gray)};
  background-repeat: no-repeat;
  background-position: 50%;
`;
const Wrap = styled_1.styled.div `
  position: relative;
  width: 100%;
  height: 100%;

  overflow: hidden;
  ${(_, { $ratio }) => $ratio &&
    (0, styled_1.css) `
      aspect-ratio: ${$ratio};
    `}
  img {
    ${(_, { $placeholder }) => $placeholder && placeholderStyle}
  }
`;
const TRANSPARENT_PLACEHOLDER = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
function Image(_a) {
    var { img, aspectRatio, customContext, context, className, static: isStaticPath, layout = 'fill' } = _a, props = __rest(_a, ["img", "aspectRatio", "customContext", "context", "className", "static", "layout"]);
    const [hasError, setHasError] = (0, react_1.useState)(false);
    const { name, alt, ratio, thumb } = img !== null && img !== void 0 ? img : {};
    const resolvedAssetPath = (0, hooks_1.useAssetsPath)(context, name);
    const assetPath = name ? resolvedAssetPath : undefined;
    const src = (0, react_1.useMemo)(() => {
        if (!name) {
            return;
        }
        if (isStaticPath) {
            return name;
        }
        return customContext && context ? `${context}/${name}` : assetPath;
    }, [assetPath, context, customContext, isStaticPath, name]);
    const blurUrl = name ? blurhashDataUrl(thumb, name) : undefined;
    return ((0, jsx_runtime_1.jsx)(Wrap, Object.assign({ "$ratio": aspectRatio ? ratio : undefined, className: className, "$placeholder": !src || hasError || undefined }, { children: (0, jsx_runtime_1.jsx)(image_1.default, Object.assign({ src: src !== null && src !== void 0 ? src : TRANSPARENT_PLACEHOLDER, alt: alt !== null && alt !== void 0 ? alt : altFromFilename(name !== null && name !== void 0 ? name : 'unknown'), lazyBoundary: "500px", layout: layout, objectFit: "cover", quality: 90, onError: () => setHasError(true) }, (blurUrl && { placeholder: 'blur', blurDataURL: blurUrl }), (layout !== 'fill' && {
            width: ratio !== null && ratio !== void 0 ? ratio : 1,
            height: 1,
        }), props)) })));
}
exports.Image = Image;
function altFromFilename(filename) {
    const { name } = (0, utils_1.splitFileName)(filename !== null && filename !== void 0 ? filename : '');
    const kebab = (0, utils_1.toKebabCase)(name.replaceAll(/[^\w\-_\s]/gu, ''));
    return kebab.replaceAll(/-+/gu, ' ').trim();
}
function blurhashDataUrl(blurhash, name) {
    if (!blurhash) {
        console.warn(`Missing thumbnail for ${name}`);
        return null;
    }
    const [w, h, colors] = [
        PLACEHOLDER_IMAGE_WIDTH,
        PLACEHOLDER_IMAGE_HEIGHT,
        PLACEHOLDER_IMAGE_COLORS,
    ];
    const pixels = (0, utils_1.decodeBlurhash)(blurhash, w, h);
    const png = (0, upng_js_1.encode)([pixels], w, h, colors);
    const u8Png = new Uint8Array(png);
    const base64 = env_1.IS_SERVER
        ? Buffer.from(u8Png).toString('base64')
        : window.btoa(String.fromCodePoint(...u8Png));
    return `data:image/png;base64,${base64}`;
}
